<template>
  <v-app>
    <AppHeader ref="appHeader"/>

    <v-main class="main-body">
      <!-- body -->
      <v-container>
        <v-row>
          <v-col sm="12" md="12" cols="12">
            <v-card elevation="0" color="#F4F4F4">
              <v-card-title>{{curLanguage == 'en' ? curBanner.title: curBanner.title_zh}}</v-card-title>
              <v-card-text>{{curLanguage == 'en' ?curBanner.content: curBanner.content_zh}}</v-card-text>
              <v-row style="justify-content: center;">
                <v-col sm="10" md="10" cols="10">
                  <v-select
                    @change="selectCoin"
                    light
                    v-model="coinType"
                    :items="coinTypes"
                    item-text="name"
                    return-object
                    dense
                    color="#222222"
                    outlined
                    label="选择币种"
                    style="font-size:12px;border-color:#DEDCDC;"
                  >
                    <template v-slot:item="{ item }">
                      <div class="d-flex align-center">
                        <v-img
                          v-if="item.icon"
                          :src="item.icon"
                          max-width="24"
                          max-height="24"
                          class="mr-2"
                        ></v-img>
                        <span>{{ item.name }}</span>
                      </div>
                    </template>
                    <template v-slot:selection="{ item }">
                      <div class="d-flex align-center">
                        <v-img
                          v-if="item.icon"
                          :src="item.icon"
                          max-width="24"
                          max-height="24"
                          class="mr-2"
                        ></v-img>
                        <span>{{ item.name }}</span>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <v-col sm="10" md="10" cols="10" class="no-padding-height">
                  <v-text-field
                    v-model="customContractAddress"
                    label="合约地址"
                    outlined
                    dense
                    color="#222222"
                    style="font-size:12px;border-color:#DEDCDC;"
                    :disabled="!coinType.isCustom"
                    @input="updateCustomAddress"
                  ></v-text-field>
                </v-col>
                <v-col sm="10" md="10" cols="10" class="no-padding-height">
                  <v-text-field
                    v-model="price"
                    :rules="priceRules"
                    type="number"
                    :label="$t('home.balance') + ':' + balance"
                    success
                    required
                  ></v-text-field>
                </v-col>
                <v-col sm="10" md="10" cols="10" class="no-padding-height">
                  <v-btn @click="reward" :loading="confirmStatus" color="#4737FF" elevation="1" tile class="head-btn" style="margin: 20px 0px;width:100%;">
                    <span style="color:white;">{{ $t('home.reward') }}</span>
                  </v-btn>
                </v-col>

              </v-row>
            
            </v-card>
          </v-col>

          
        </v-row>

        
        <v-row> 
          <v-col sm="12" md="12" cols="12">
            <v-card elevation="0" color="#F4F4F4">
              
              <v-row class="card-box">
                <v-col 
                  v-for="(item, n) in exploreJson"
                  :key=n
                  xs="6" sm="3" md="3" cols="6">
                  
                </v-col>
                
              </v-row>
              
            </v-card>
          </v-col>
        </v-row>

        
      </v-container>
    </v-main>
    <dialog-loader ref="dialogLoader"></dialog-loader>
    <confirm-dialog ref="confirmDialog" />
    <h-dialog />
    <v-dialog v-model="showCustomAddressDialog" max-width="500px">
      <v-card>
        <v-card-title>输入自定义合约地址</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="customContractAddress"
            label="合约地址"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showCustomAddressDialog = false">取消</v-btn>
          <v-btn color="primary" text @click="confirmCustomAddress">确认</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <h-notify />
    <h-loader /> -->

  </v-app>
</template>

<script>
import AppHeader from '../../components/AppHeader.vue';
import ConfirmDialog from '../../components/ConfirmDialog.vue';

export default {
  name: 'App',

  components: {
    AppHeader,
    ConfirmDialog
  },

  data: () => ({
    balance: '-',
    confirmStatus: false,
    price: null,
    priceRules: [
      v => !!v || 'Price is required'
    ],
    coinType: {},
    coinTypes: [{
      name: "自定义合约地址",
      address: "",
      isCustom: true,
      icon: ""
    },{
      name: "CFX",
      address: "cfx:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa0sfbnjm2",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aacg158kvr8zanb1bs048ryb6rtrhr283ma70vz70tx.svg"
    },{
      name: "USDT",
      address: "cfx:acf2rcsh8payyxpg6xj7b0ztswwh81ute60tsw35j7",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aacf2rcsh8payyxpg6xj7b0ztswwh81ute60tsw35j7.png"
    },{
      name: "FC",
      address: "cfx:achc8nxj7r451c223m18w2dwjnmhkd6rxawrvkvsy2",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aachc8nxj7r451c223m18w2dwjnmhkd6rxawrvkvsy2.svg"
    },{
      name: "ABC",
      address: "cfx:acb78besxg2tnxs1ccca45g2fm412mdpr6b0ve6wtc",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aacb78besxg2tnxs1ccca45g2fm412mdpr6b0ve6wtc.jpeg"
    },{
      name: "USDC",
      address: "cfx:aca13suyk7mbgxw9y3wbjn9vd136swu6s21tg67xmb",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aaca13suyk7mbgxw9y3wbjn9vd136swu6s21tg67xmb.png"
    },{
      name: "GAD",
      address: "cfx:accebz8w353x5940c1c4w0f5827f61vjv2ehk8ngv2",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aaccebz8w353x5940c1c4w0f5827f61vjv2ehk8ngv2.png"
    },{
      name: "MOON",
      address: "cfx:achcuvuasx3t8zcumtwuf35y51sksewvca0h0hj71a",
      isCustom: false,
      icon: "https://scanglobal.oss-cn-hongkong.aliyuncs.com/mainnet/cfx%3Aachcuvuasx3t8zcumtwuf35y51sksewvca0h0hj71a.png"
    }],
    isShow: -1,
    account: null,
    curLanguage: 'zh-cn',
    curActiveTab: 0,
    curBanner: {
      title: 'Reward ConfluxDapp',
      title_zh: '打赏 ConfluxDapp',
      content: 'Reward it, and you will be very rich in the future.',
      content_zh: '听说一位即将暴富的大佬，打赏了 ConfluxDapp。',
    },
    clockIcon: require('../../assets/svg/clock.svg'),
    trendingJson: [],
    hotbidJson: [],
    exploreJson: [],
    categoryList: [],
    boxList: [],
    currentCategory: 0,
    timelock: null,
    customContractAddress: '',
    showCustomAddressDialog: false,
  }),
  mounted: async function() {
    //TODO:
    this.account = await this.$refs.appHeader.login();
   
  },
  watch: {
    account: {
      handler(newVal, oldVal) {
        
      },
      immediate: true
    },
    '$i18n.locale': {
      handler(newVal, oldVal) {

        if(newVal == 'zh-cn') {
          this.curLanguage = 'zh-cn'
        }
        if(newVal == 'en') {
          this.curLanguage = 'en'
        }
        
        
      },
      immediate: true
    }
  },
  beforeDestroy: function() {
    this.destoryClock()
  },
  methods: {
    login: async function() {
      this.account = await this.$refs.appHeader.login();
    },
    reward: async function() {
      console.log("reward")
      if(this.balance < this.price) return;
      this.confirmStatus = true
      let that = this
      try {
        let result = await that.transferToken(this.coinType.address, this.globalVar.account, "cfx:aatnwhyaf3sz4vt088nnr73vt3czp34fsjsaw30v1e", this.price)
        console.log(result)
        if(0 == result.outcomeStatus) {
          console.log(result.transactionHash)
          this.price = ''
          this.coinType = {}

          try {
          
            let title = that.$i18n.locale != 'en' ? "鸣谢": "Give thanks"
            let text_en = "Thank you, boss, for your gift."
            let text_cn = "感谢老板的馈赠，预感您将要暴富了！"
            let validBidText = that.$i18n.locale != 'en' ? text_cn : text_en
            let btns = that.$i18n.locale != 'en' ? ["取消","确认"]: ["Cancel","Confirm"]

            that.$refs.confirmDialog.confirm(title, validBidText , btns, async function() {
              
            })
            
          } catch(e) {
            console.log(e)
          }
        }
        
      } catch(e) {
        this.confirmStatus = false
      }
      
      this.confirmStatus = false
    },
    selectCoin: async function() {
      let that = this
      if (this.coinType.isCustom) {
        this.customContractAddress = ''  // 清空输入框
        this.coinType.address = ''  // 清空地址
        this.balance = '-'  // 清空余额显示
      } else {
        this.customContractAddress = this.coinType.address
        // 如果有地址，就查询余额
        if (this.coinType.address) {
          let balance = await that.getBalance(this.globalVar.account, this.coinType.address)
          this.balance = balance
        }
      }
    },
    updateCustomAddress: function() {
      if (this.coinType.isCustom && this.customContractAddress) {
        this.coinType.address = this.customContractAddress
        // 查询余额
        this.getBalance(this.globalVar.account, this.coinType.address).then(balance => {
          this.balance = balance
        })
      }
    },
    destoryClock: function() {
      window.clearInterval(this.timelock)
      this.timelock = null
    },
    dealClock: function() {
      let that = this
      
      for(var i = 0 ; i < that.hotbidJson.length; i++) {
        if(null != that.hotbidJson[i].expirationTime) {
          
          let tempTime = that.hotbidJson[i].expirationTime
          that.hotbidJson[i].expirationTime = null
          that.hotbidJson[i].expirationTime = tempTime
        }
        
      }
      
    },
    loadCategory: function() {
      //Category
      window.API.category.getCategoryList.request({
        "count": 0,
        "pageSize": 10
      }).then(res => {
        this.categoryList = res.data.data.categoryList
      })
    },
    loadHotBid: function() {
      let that = this
      that.$refs.dialogLoader.show( that.$i18n.locale == 'en' ? 'Data Loading...' : '数据加载中...', { color: 'primary' } )

      that.destoryClock()
      //hot bid
      window.API.item.browseItemList.request({
        "category": "1",
        "count": 0,
        "pageSize": 4,
        "sortBy": "highestBid",
        "status": "auction"
      }).then(res => {
        if(0 == res.data.code) {
          this.hotbidJson = this.packageCollectibleData(res.data.data.itemList)

          that.timelock = setInterval(function() {
            that.dealClock()
          }, 1000)
        }

        that.$refs.dialogLoader.hide()
      })
    },
    listExplore(category) {
      let that = this
      //Expolre
      window.API.item.browseItemList.request({
        "category": '',
        "count": 0,
        "pageSize": 4,
        "sortBy": "recentList",
        "status": "buyNow"
      }).then(res => {
        
        if(0 == res.data.code) {
          
          that.exploreJson = this.packageCollectibleData(res.data.data.itemList)
        }
      })
    },
    loadCollection: function() {
      
      let that = this

      let params = {
        count: 0,
        pageSize: 4
      }

      window.API.collection.getTrendingCollectionList.request(params).then(res => {
        if(0 == res.data.code) {
          that.trendingJson = res.data.data.trendingCollection
        }
      })
      
    },

    loadBlindBox: function() {
      let that = this

      window.API.box.searchBox.request({
        "count": 0,
        "pageSize": 4,
        "search": '',
        "sortBy": ''
      }).then(res => {
        if(0 == res.data.code) {
          that.boxList = res.data.data.boxList
        }
        
      })
    },
    viewDetail4HotBid: function(n, type) {
      let id = this.hotbidJson[n]['id']
      this.$router.push({ name: 'Detail', params: {id: id, listingStatus: 1}, query: {id: id, listingStatus: 1}})
    },
    viewDetail: function(n, type) {
      let id = this.exploreJson[n]['id']
      this.$router.push({ name: 'Detail', params: {id: id, listingStatus: 1}, query: {id: id, listingStatus: 1}})
    },
    showMore: function() {
      // this.sheet = true;
      this.drawer = true;
    },
    showExplore: function(n) {

      if(typeof n == "number") {
        let collectionId = this.trendingJson[n].id
        this.$router.push({ name: 'Explore', params: {collectionId: collectionId}, query: {collectionId: collectionId}})
      } else {
        this.$router.push({ name: 'Explore', params: {}})
      }
      
    },
    showBlindBoxDetail: function(n, type){
      //添加样式
      this.isShow = n 

      let id = this.boxList[n]['id']
      this.$router.push({ name: 'BlindBoxDetail', params: {id: id, onlineOrNot: 1}, query:{id: id, onlineOrNot: 1}});
    }
  }

};
</script>

<style scoped>

  .tuoyuan {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #7CD77B;
  }

  .main-body {
    background-color: #F4F4F4;
  }


  .head-img {
    margin: 0px 16px;
  }

  .card-box {
    padding-left: 16px;
  }

  .rectangle{
    width: 9vw;
    position: absolute;
    right: 0;
    top: 0;
    display: none;
  }

  .blind_box_img{
    position: absolute; 
  }

  .blind_box:before{
    content: '';
    padding-top: 100%;
    box-sizing: border-box;
    display: block;
    width: 0;
  }

  .open_now_btn{
    background: linear-gradient(90deg, #1434E1 2.87%, #4737FF 53.42%, rgba(20, 52, 225, 0.1) 100%);
    border-radius: 0px 16px 16px 16px;
    width: 40%;
    min-width: 78px!important;
    max-width: 400px!important;
    position: absolute;
    letter-spacing: -1px;
    color: #F8F8FA;
  }

  .blind_box{
    background: linear-gradient(0.39deg, #E4E4E4 0.25%, #FFFFFF 57.15%, #FFFFFF 99.57%);
    border-radius: 8px;
  }

  .active {
    border: 1px solid rgba(34, 34, 34);
  }

  .show {
    display: flex;
    width: 100%;
    margin:0;
  }

  .blind_box_price{
    font-family: Fira Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 10.6pt;
    text-align: right;
    letter-spacing: -1px;
    position: absolute;
    color: #1434E1;
    right: 9%;
    bottom: 16%;
  }

  
</style>
